import React from 'react'
import "./Chats.css";
import Chat from './Chat';
import { Link } from 'react-router-dom';

function Chats({name, message, profilePic, timestamp}) {
    return (
        <div className="chats">
            <Link to={`/chat/${name}`}>
                <Chat
                    name="Steve"
                    message="What's Up Bro"
                    timestamp="5 second ago"
                    profilePic="https://www.biography.com/.image/t_share/MTY2MzU3OTcxMTUwODQxNTM1/steve-jobs--david-paul-morrisbloomberg-via-getty-images.jpg"
                />
                <Chat
                    name="Mark"
                    message="Yo What's Up"
                    timestamp="20 second ago"
                    profilePic="https://i.insider.com/5ef9edbb2618b9128316526a?width=600&format=jpeg&auto=webp"
                />
                <Chat
                    name="Ellon"
                    message="This App is Awesome"
                    timestamp="2 minute ago"
                    profilePic="https://e3.365dm.com/20/04/2048x1152/skynews-elon-musk-tesla-lockdown_4980036.jpg"
                />
                <Chat
                    name="Mark"
                    message="Bro this is amazing"
                    timestamp="5 minute  ago"
                    profilePic="https://i.insider.com/5ef9edbb2618b9128316526a?width=600&format=jpeg&auto=webp"
                />
            </Link>
           
        </div>
    )
}

export default Chats
